import classNames from 'classnames';
import React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { zeroPad } from '../../../ZeroPad';

interface BankIdSessionIndicatorProgressBarProps {
    durationToExpiry?: Duration;
    redBackgroundMinutesThreshold: number;
    rxSessionValidityDefaultTimeInMinutes: number;
}

export const BankIdSessionIndicatorProgressBar = (props: BankIdSessionIndicatorProgressBarProps) => {
    const barPercentage =
        props.durationToExpiry &&
        (100 * (props.durationToExpiry!.minutes! * 60 + props.durationToExpiry.seconds!)) / (props.rxSessionValidityDefaultTimeInMinutes * 60);

    return (
        <>
            {props.durationToExpiry !== undefined && (
                <div className="BankIdSessionIndicator__Wrapper">
                    <div className="BankIdSessionIndicator__SecuredSessionWrapper">
                        <div className="BankIdSessionIndicator__SecuredSessionText">{getTranslation(keys['bankId.yourSecureSession'])}:</div>
                        <div className="BankIdSessionIndicator__TimeLeftText">
                            {zeroPad(props.durationToExpiry!.minutes)} : {zeroPad(props.durationToExpiry!.seconds)}
                        </div>
                    </div>
                    <div className="BankIdSessionIndicatorProgressBar__Wrapper">
                        <div
                            className={classNames(
                                'BankIdSessionIndicatorProgressBar__TimeLeftBar',
                                props.durationToExpiry.minutes !== undefined &&
                                    props.durationToExpiry!.minutes < props.redBackgroundMinutesThreshold &&
                                    'BankIdSessionIndicatorProgressBar__TimeLeftBar--Red'
                            )}
                            style={{ width: `${barPercentage}%` }}
                        ></div>
                    </div>
                </div>
            )}
        </>
    );
};
